<template>
    <div id="device-card">   

        <!-- card -->
        <div style="width:100%; float:left; background-color: white;">

            <div v-if="item.id =='Packaging Device 1' || item.id =='Packaging Device 2' || item.id =='Packaging Device 3' || item.id =='MIoT-PROTO-1' || item.id =='MIoT-PROTO-2'" class='img-container'>
                <img v-if="item.online" class="card-background card-img-top online" src="../assets/images/smart-packaging-online.png" alt="...">
                <img v-else class="card-background card-img-top" src="../assets/images/smart-packaging-offline.png" alt="...">
            </div> 
            
            <div v-else-if="item.id =='BioThaw-Vitrafy-00004'" class='img-container'>
                <!-- always show as off line -->
                <!-- <img class="card-background card-img-top online" style="margin-top: -23px; background-color: #f5faff !important;" src="../assets/images/thawerForCard.png" alt="..."> -->
                <img class="card-background card-img-top online" style="margin-top: 0px; background-color: #f5faff !important;" src="../assets/images/updatedThawer.png" alt="...">
            </div>

            <div v-else-if="item.id =='CASA-01'" class='img-container'>
                <!-- always show as online -->
                <img class="card-background card-img-top online" style="margin-top: -23px; background-color: #f5faff !important;" src="../assets/images/casa.png" alt="...">
            </div>            

            <div v-else-if="item.id =='VLSENGNB011' || item.id =='VLSENGNB017'" class='img-container'>
                <img v-if="item.online" class="card-background card-img-top online" src="../assets/images/laptop.png" alt="...">
                <img v-else class="card-background card-img-top" src="../assets/images/laptop-offline.png" alt="...">
            </div>
                      
            <div v-else class='img-container'>
                <img v-if="item.online" class="card-background card-img-top online" src="../assets/images/4-new.png" alt="...">
                <img v-else class="card-background card-img-top" src="../assets/images/4-new-offline.png" alt="...">
            </div>

            <div class="content-container">
                <!-- <span v-if="item.online" class="status-badge">READY</span> -->

                <h5 class="card-title offline">
                    <span class="status-badge">READY</span>
                    <div v-if="item.id == 'BioThaw-Vitrafy-00004'">BioThaw-00004</div> <!-- adjust BioThaw-Vitrafy-00004 name to fit in card -->
                    <div v-else>{{ item.id }}</div>
                </h5>

                <!-- always show BioThaw-Vitrafy-00004 as online -->
                <p v-if="item.id == 'BioThaw-Vitrafy-00004'" class="card-text offline">
                    {{ item.details }}<br />
                    <!-- <span class="status-badge">READY</span><b-badge pill variant="info" style="margin-left: 10px;">{{(getDeviceOperationStatus())}}</b-badge> -->
                </p>
                <p v-else class="card-text offline">
                    {{ item.details }}<br />
                    <!-- <span v-if="item.online" class="badge bg-success">Online</span> -->
                    <!-- <span v-if="item.online" class="status-badge">READY</span> -->
                    <!-- <span v-else class="badge bg-secondary">Offline</span><b-badge pill variant="info" style="margin-left: 10px;">{{(getDeviceOperationStatus())}}</b-badge> -->
                </p>

                <div v-if="item.id == 'Vitrafy-00001'">
                    <div v-if="item.online" class="bigTempDataContainer">
                        <div class="bigTempData" :class="[$parent.deviceTempAndFlow[0].belowZero ? 'belowZero' : '']">
                            <img v-if="$parent.deviceTempAndFlow[0].belowZero" class="" src="../assets/images/snowflake.png" alt="...">
                            {{ $parent.deviceTempAndFlow[0].temp }} °C
                        </div>
                        <div class="smallTempData">
                            {{ $parent.deviceTempAndFlow[0].flow }} L/min
                        </div>
                    </div>
                </div>
                <div v-if="item.id == 'Vitrafy-00002'">
                    <div v-if="item.online" class="bigTempDataContainer">
                        <div class="bigTempData" :class="[$parent.deviceTempAndFlow[1].belowZero ? 'belowZero' : '']">
                            <img v-if="$parent.deviceTempAndFlow[1].belowZero" class="" src="../assets/images/snowflake.png" alt="...">
                            {{ $parent.deviceTempAndFlow[1].temp }} °C
                        </div>
                        <div class="smallTempData">
                            {{ $parent.deviceTempAndFlow[1].flow }} L/min
                        </div>
                    </div>
                </div>
                <div v-else-if="item.id == 'Vitrafy-00004'">
                    <div v-if="item.online" class="bigTempDataContainer">
                        <div class="bigTempData" :class="[$parent.deviceTempAndFlow[2].belowZero ? 'belowZero' : '']">
                            <img v-if="$parent.deviceTempAndFlow[2].belowZero" class="" src="../assets/images/snowflake.png" alt="...">
                            {{ $parent.deviceTempAndFlow[2].temp }} °C
                        </div>
                        <div class="smallTempData">
                            {{ $parent.deviceTempAndFlow[2].flow }} L/min
                        </div>
                    </div>
                </div>
                <div v-if="item.id == 'Vitrafy-00005'">
                    <div v-if="item.online" class="bigTempDataContainer">
                        <div class="bigTempData" :class="[$parent.deviceTempAndFlow[3].belowZero ? 'belowZero' : '']">
                            <img v-if="$parent.deviceTempAndFlow[3].belowZero" class="" src="../assets/images/snowflake.png" alt="...">
                            {{ $parent.deviceTempAndFlow[3].temp }} °C
                        </div>
                        <div class="smallTempData">
                            {{ $parent.deviceTempAndFlow[3].flow }} L/min
                        </div>
                    </div>
                </div>
                <div v-else-if="item.id == 'Vitrafy-00006'">
                    <div v-if="item.online" class="bigTempDataContainer">
                        <div class="bigTempData" :class="[$parent.deviceTempAndFlow[4].belowZero ? 'belowZero' : '']">
                            <img v-if="$parent.deviceTempAndFlow[4].belowZero" class="" src="../assets/images/snowflake.png" alt="...">
                            {{ $parent.deviceTempAndFlow[4].temp }} °C
                        </div>
                        <div class="smallTempData">
                            {{ $parent.deviceTempAndFlow[4].flow }} L/min
                        </div>
                    </div>
                </div>
                <div v-else-if="item.id == 'Vitrafy-00007'">
                    <div v-if="item.online" class="bigTempDataContainer">
                        <div class="bigTempData" :class="[$parent.deviceTempAndFlow[6].belowZero ? 'belowZero' : '']">
                            <img v-if="$parent.deviceTempAndFlow[6].belowZero" class="" src="../assets/images/snowflake.png" alt="...">
                            {{ $parent.deviceTempAndFlow[6].temp }} °C
                        </div>
                        <div class="smallTempData">
                            {{ $parent.deviceTempAndFlow[6].flow }} L/min
                        </div>
                    </div>
                </div>
                <div v-if="item.id == 'Vitrafy-00009'">
                    <div v-if="item.online" class="bigTempDataContainer">
                        <div class="bigTempData" :class="[$parent.deviceTempAndFlow[7].belowZero ? 'belowZero' : '']">
                            <img v-if="$parent.deviceTempAndFlow[7].belowZero" class="" src="../assets/images/snowflake.png" alt="...">
                            {{ $parent.deviceTempAndFlow[7].temp }} °C
                        </div>
                        <div class="smallTempData">
                            {{ $parent.deviceTempAndFlow[7].flow }} L/min
                        </div>
                    </div>
                </div>
                <div v-if="item.id == 'Vitrafy-00011'">
                    <div v-if="item.online" class="bigTempDataContainer">
                        <div class="bigTempData" :class="[$parent.deviceTempAndFlow[8].belowZero ? 'belowZero' : '']">
                            <img v-if="$parent.deviceTempAndFlow[8].belowZero" class="" src="../assets/images/snowflake.png" alt="...">
                            {{ $parent.deviceTempAndFlow[8].temp }} °C
                        </div>
                        <div class="smallTempData">
                            {{ $parent.deviceTempAndFlow[8].flow }} L/min
                        </div>
                    </div>
                </div>
                <!-- <div v-else-if="item.id == 'Vitrafy-00010'">
                    <div v-if="item.online" class="bigTempDataContainer">
                        <div class="bigTempData" :class="[$parent.deviceTempAndFlow[5].belowZero ? 'belowZero' : '']">
                            <img v-if="$parent.deviceTempAndFlow[5].belowZero" class="" src="../assets/images/snowflake.png" alt="...">
                            {{ $parent.deviceTempAndFlow[5].temp }} °C
                        </div>
                        <div class="smallTempData">
                            {{ $parent.deviceTempAndFlow[5].flow }} L/min
                        </div>
                    </div>
                </div> -->
                <!-- <div v-if="item.id == 'Vitrafy-HP00001'">
                    <div v-if="item.online" class="bigTempDataContainer">
                        <div class="bigTempData" :class="[$parent.deviceTempAndFlow[6].belowZero ? 'belowZero' : '']">
                            <img v-if="$parent.deviceTempAndFlow[6].belowZero" class="" src="../assets/images/snowflake.png" alt="...">
                            {{ $parent.deviceTempAndFlow[6].temp }} °C
                        </div>
                        <div class="smallTempData">
                            {{ $parent.deviceTempAndFlow[6].flow }} L/min
                        </div>
                    </div>
                </div> -->

                <div v-else-if="item.id == 'Packaging Device 2' || item.id == 'Packaging Device 3'">
                    <div v-if="item.online" class="bigTempDataContainer">
                        <div class="bigTempData">
                            {{ item.SensorTemp }} °C
                        </div>
                        <div class="smallTempData">
                            {{ item.SensorRH }} % rh
                        </div>
                    </div>
                </div>                
                <div v-else>
                    <!-- currently empty -->
                </div>
            </div>
        </div>

        <div class="card-footer" style="width: 100%; float:left; position: relative; background-color: #F7F7F7">
            <router-link to="/Device5" v-if="item.id != 'Raspberry-Pi-2'">
                <button type="button" class="btn btn btn-outline btn-sm action-button disabled"><span style="color: #F7F7F7;">DATA</span></button>
            </router-link>         

            <!-- Packaging Device 2 & Packaging Device 2 -->
            <div v-if="item.id == 'Packaging Device 2' || item.id == 'Packaging Device 3'">
                <button v-b-modal="'device-pi-data-modal' + item.id" @click="pi2DataClick()" type="button" class="btn btn-outline-primary btn-sm action-button data-button" style="position: absolute; right: 80px"><i class="fa-solid fa-chart-simple"></i><span style="padding-left:10px">Data</span></button>
            </div>

            <!-- Cryo devices linked to Lifelink live data feed -->
            <div v-if="item.id == 'Vitrafy-00001' || item.id == 'Vitrafy-00002' || item.id == 'Vitrafy-00004' || item.id == 'Vitrafy-00005' || item.id == 'Vitrafy-00006' || item.id == 'Vitrafy-00007' || item.id == 'Vitrafy-00009' || item.id == 'Vitrafy-00010' || item.id == 'Vitrafy-00011'">
                <button v-b-modal="'device-data-modal' + item.id" type="button" class="btn btn-outline-primary btn-sm action-button data-button" style="position: absolute; right: 80px" @click="deviceDataShow()"><i class="fa-solid fa-chart-simple"></i><span style="padding-left:10px">Data</span></button>
            </div>

            <!-- MIoT Devices linked to Lifelink live data feed -->
            <div v-if="item.id == 'MIoT-PROTO-1' || item.id == 'MIoT-PROTO-2'">
                <button v-b-modal="'miot-data-modal' + item.id"  type="button" class="btn btn-outline-primary btn-sm action-button data-button" style="position: absolute; right: 80px" @click="miotModalShow('miot-data-modal' + item.id)"><i class="fa-solid fa-chart-simple"></i><span style="padding-left:10px">Data</span></button>
            </div>

            <!-- info (all) -->
            <button type="button" v-b-modal="'device-info-modal' + item.id" class="btn btn-outline-primary btn-sm action-button data-button" style="position: absolute; right: 0"><i class="fa-solid fa-circle-info"></i><span style="padding-left:10px">Info</span></button>

        </div> 
        <!-- END card -->

        <!-- info modal -->
        <b-modal :id="'device-info-modal' + item.id" size="lg">
            <!-- title -->
            <template #modal-title>
                <i class="fa-solid fa-circle-info"></i><span class="modal-title">Info - {{ item.id }}</span>
            </template>

            <!-- info container -->
            <div>
                <!-- image -->
                <div style="float: left; margin-right: 20px;">
                    <div v-if="item.id =='Packaging Device 1' || item.id =='Packaging Device 2' || item.id =='Packaging Device 3' || item.id =='Packaging Device 7'" class='img-container'>
                        <img v-if="item.online" class="card-background card-img-top online" style="margin-top: -23px;" src="../assets/images/smart-packaging-online.png" alt="...">
                        <img v-else class="card-background card-img-top" src="../assets/images/smart-packaging-offline.png" alt="...">
                    </div> 
                    
                    <div v-else-if="item.id =='BioThaw-Vitrafy-00004'" class='img-container'>
                        <!-- <img class="card-background card-img-top online" style="margin-top: -23px; background-color: #f5faff !important;" src="../assets/images/thawerForCard.png" alt="..."> -->
                        <img class="card-background card-img-top online" style="margin-top: 0px; background-color: #f5faff !important;" src="../assets/images/updatedThawer.png" alt="...">
                    </div>

                    <div v-else-if="item.id =='CASA-01'" class='img-container'>
                        <img class="card-background card-img-top online" style="margin-top: -23px; background-color: #f5faff !important;" src="../assets/images/casa.png" alt="...">
                    </div>                    

                    <div v-else-if="item.id =='VLSENGNB011'" class='img-container'>
                        <img v-if="item.online" class="card-background card-img-top online" src="../assets/images/laptop.png" alt="...">
                        <img v-else class="card-background card-img-top" src="../assets/images/laptop-offline.png" alt="...">
                    </div>
                            
                    <div v-else class='img-container'>
                        <img v-if="item.online" class="card-background card-img-top online" src="../assets/images/4-new.png" alt="...">
                        <img v-else class="card-background card-img-top" src="../assets/images/4-new-offline.png" alt="...">                                        
                    </div>
                </div>                    

                <!-- table -->
                <div style="float: left; max-width: 530px;">
                    <table class="table">
                        <tbody>
                            <tr class="">
                                <td>Device Name</td>
                                <td>{{ item.id }}</td>
                            </tr>
                            <tr class="">
                                <td>Device Type</td>
                                <td>{{ item.details }}</td>
                            </tr>
                            <tr class="">
                                <td>Location</td>
                                <td>{{ item.location }}</td>
                            </tr>                            
                            <tr v-if="item.online" class="">
                                <td>Status</td>
                                <td>
                                    <!-- <span v-if="device.online" class="status-badge" style="margin-bottom: 0 !important">READY</span>
                                    <span v-else class="status-badge" style="background-color: #c2c2c2; margin-bottom: 0 !important;">OFFLINE</span> -->
                                    <span class="status-badge" style="margin-bottom: 0 !important">READY</span>
                                </td>
                            </tr>
                            <tr v-else class="">
                                <td>Status</td>
                                <td>
                                    <!-- <span v-if="device.online" class="status-badge" style="margin-bottom: 0 !important">READY</span>
                                    <span v-else class="status-badge" style="background-color: #c2c2c2; margin-bottom: 0 !important;">OFFLINE</span> -->
                                    <span class="status-badge" style="margin-bottom: 0 !important">READY</span>
                                </td>
                            </tr>
                            <tr class="">
                                <td>Uptime</td>
                                <!-- <td>{{ item.deviceUptime }}</td> -->
                                <td v-if="item.id == 'CASA-01'">{{  timeSince('10/01/2026 12:16 PM') }}</td>
                                <td v-else>{{  timeSince('01/01/2026 11:47 PM') }}</td>                        
                            </tr>                            
                            <tr class="">
                                <td>Last Communication</td>
                            <td>
                                <!-- {{ item.convertedTimestamp }} <br />  -->
                                <!-- {{ item.lastCommunicationSeconds }} seconds ago <br /> -->
                                <!-- {{ item.formattedLastCommunicationSeconds }}<br /> -->
                                {{ getCurrentDateTime() }}
                            </td>
                            </tr>                            
                            <tr class="">
                                <td>Device Software Version</td>
                                <td v-if="item.lifeLinkUpToDate">
                                    {{ item.lifelinkVersion }} <b-alert style="margin: 0; padding: 0; display: inline-block; padding-left: 4px; padding-right: 5px; margin-left: 10px;" show variant="success"><font-awesome-icon icon="fa-solid fa-check" /><span> Up to date</span></b-alert>
                                </td>
                                <td v-else>
                                    <span v-if="item.id == 'CASA-01'">2.4.1 <b-alert style="margin: 0; padding: 0; display: inline-block; padding-left: 4px; padding-right: 5px; margin-left: 10px;" show variant="warning"><font-awesome-icon icon="fa-solid fa-exclamation-circle" /><span> Update available <a href="#">update now</a></span></b-alert></span>
                                    <span v-else>1.4.1 <b-alert style="margin: 0; padding: 0; display: inline-block; padding-left: 4px; padding-right: 5px; margin-left: 10px;" show variant="warning"><font-awesome-icon icon="fa-solid fa-exclamation-circle" /><span> Update available <a href="#">update now</a></span></b-alert></span>
                                </td>                                
                            </tr>
                            <tr v-if="item.id != 'CASA-01'" style="display: none;">
                                <td>Device Information</td>
                                <td>
                                    <table id="info-table" v-bind:class="{'whiteTable':!item.online}" style="margin-bottom: 0px;">
                                        <tr>
                                            <td class="info-title">CPU</td>
                                            <td style="padding-left: 5px;">{{ item.deviceCPU }}%</td>
                                            <td class = "chart">
                                                <div class="progress" v-bind:class="{'hide-element':item.offline}">
                                                    <div class="progress-bar" role="progressbar" v-bind:style="{ width: item.deviceCPU + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="info-title">MEM</td>
                                            <td style="padding-left: 5px;">{{ item.deviceMEM }}%</td>
                                            <td class = "chart">
                                                <div class="progress" v-bind:class="{'hide-element':item.offline}">
                                                    <div class="progress-bar" role="progressbar" v-bind:style="{ width: item.deviceMEM + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </td>
                                        </tr> 
                                        <tr v-if="item.sensorDevice && item.online" class="info-title">
                                            <td>SENSOR</td>
                                            <td colspan="2" style="padding-left: 5px;">{{ item.sensorData }} (DHT22 temperature-humidity sensor)</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div> 

            <template #modal-footer>
                <button v-b-modal.modal-close_visit class="btn btn-sm btn-secondary" @click="$bvModal.hide('device-info-modal' + item.id)">Close</button>
            </template>
        </b-modal>

        <!-- pi data modal -->
        <b-modal :id="'device-pi-data-modal' + item.id" scrollable size="xl" @hide="pi2DataHide()">
            <!-- title-->
            <template #modal-title>
                <i class="fa-solid fa-chart-simple"></i><span class="modal-title">Data - {{ item.id }}</span>
            </template>

            <div>
                <!-- loading spinner -->
                <div id="live-data-loading">
                    <div class="lds-facebook"><div></div><div></div><div></div></div>
                    <div>Connecting to live data feed...</div>
                </div>

                <!-- live data content -->
                <div v-if="autoFetchData" id="live-data-container" style="display: none;">

                    <!-- Live icon (flashing) -->
                    <div style="position: relative;padding-left:20px;">
                        <span :style="{color: getLiveStatusColour()}" style="font-weight: bold;">LIVE DATA</span>
                        <svg height="50" width="50" :class="(getDeviceSleepStatus(item.deviceTimestamp) ? '' : 'blinking')" style="position:absolute; top:-9px; left:-11px;">
                            <circle cx="20" cy="20" r="5" :fill="getLiveStatusColour()" />
                        </svg> 

                        <span style="padding-left: 10px;">Last Communication: {{ item.formattedLastCommunicationSeconds }}</span>

                        <!-- <date-picker v-model="deviceDataDateRange" type="datetime" range valueType="x"></date-picker> -->
                    </div>

                    <br />

                    <div style="float:left; width:100%; margin-bottom: 40px;">
                        <!-- device location desktop -->
                        <div id="device-location-desktop" style="display: inline-block; width: 50%; padding-right: 20px; float: left;">
                            <h4>Location</h4>
                            <!-- <PackagingTracking ref="PackagingTracking"/> -->
                            <PackagingTracking_dynamic ref="PackagingTracking_dynamic" :item="item" :zoom_level="map_zoom_level" :sensorData="sensorData" :dataDateRange="deviceDataDateRange" />
                            
                        </div>
                        <!-- device data -->
                        <div id="device-data" style="display: inline-block; width: 50%; padding-left: 20px; float: left;">
                            <h4>Sensor Data</h4>
                            <!-- Temperature Chart -->
                            <div>
                                <div style="position: relative;">
                                    <h1 style="font-size: 48px; margin-bottom: 0; text-align: right; padding-right: 48px; padding-top: 0 !important;"> 
                                        <span v-if="temperatureChange == 'D'" style="color: red" >{{ temperature }} °C</span>
                                        <span v-if="temperatureChange == 'U'" style="color: green" >{{ temperature }} °C</span>
                                        <span v-if="temperatureChange == '-'">{{ temperature }} °C</span>
                                    </h1>
                                    <div style="position: absolute; bottom: 0; right: 10px; font-size: 48px; padding-top: 0 !important;">
                                        <font-awesome-icon v-if="temperatureChange == 'D'" icon="fa-solid fa-caret-down" style="color: red" />
                                        <font-awesome-icon v-if="temperatureChange == 'U'" icon="fa-solid fa-caret-up" style="color: green"/>
                                    </div>                                    
                                    <div style="position: absolute; bottom: 9px; right: 10px; font-size: 48px;">
                                        <font-awesome-icon v-if="temperatureChange == '-'" icon="fa-solid fa-minus" style="font-size:25px;"/>         
                                    </div>                                                                        
                                </div>
                                <div style="text-align: right; text-transform: uppercase; margin-bottom: 15px; padding-right: 10px;">temperature</div>                                
                                <div style="width: 100%; height: 200px">
                                    <canvas id="device-chart"></canvas>
                                </div>               
                            </div>   

                            <!-- Humidity  Chart -->
                            <div>
                                <div style="position: relative;">
                                    <h1 style="font-size: 48px; margin-bottom: 0; text-align: right; padding-right: 48px;"> 
                                        <span v-if="humidityChange == 'D'" style="color: red" >{{ humidity }} %</span>
                                        <span v-if="humidityChange == 'U'" style="color: green" >{{ humidity }} %</span>
                                        <span v-if="humidityChange == '-'">{{ humidity }} %</span>
                                    </h1>
                                    <div style="position: absolute; bottom: 0; right: 10px; font-size: 48px;">
                                        <font-awesome-icon v-if="humidityChange == 'D'" icon="fa-solid fa-caret-down" style="color: red" />
                                        <font-awesome-icon v-if="humidityChange == 'U'" icon="fa-solid fa-caret-up" style="color: green"/>
                                    </div>                                    
                                    <div style="position: absolute; bottom: 9px; right: 10px; font-size: 48px;">
                                        <font-awesome-icon v-if="humidityChange == '-'" icon="fa-solid fa-minus" style="font-size:25px;"/>         
                                    </div>                                                                        
                                </div>
                                <div style="text-align: right; text-transform: uppercase; margin-bottom: 15px; padding-right: 10px;">humidity</div>                                
                                <div style="width: 100%; height: 200px">
                                    <canvas id="device-chart-2"></canvas>
                                </div>               
                            </div>
                        </div>
                        <!-- device location mobile -->
                        <div id="device-location-mobile" style="display: inline-block; width: 100%; padding: 0px; float: left;">
                            <h4>Location</h4>
                            <!-- <PackagingTracking ref="PackagingTracking"/> -->
                            <PackagingTracking_dynamic ref="PackagingTracking_dynamic" :item="item" :zoom_level="map_zoom_level" :sensorData="sensorData" :dataDateRange="deviceDataDateRange" />
                        </div>
                    </div>

                    <!-- data table -->
                    <div style="float:left; width:100%">
                        <table class="table" id="live-data-table" style="float: left; width: 100%">
                            <thead>
                                <tr>
                                    <th>Timestamp</th>
                                    <th>Location</th>
                                    <th>Speed (Km/h)</th>
                                    <th>Temperature °C</th>
                                    <th>Humidity %</th>
                                </tr>                               
                            </thead>
                            <tbody>
                                <tr v-for="row in sensorData" v-bind:key="row.ID">
                                    <td> {{ row.timestamp }}</td>
                                    <td> {{ (row.latitude === undefined ? '-37.53092219073088' : row.latitude)}}, {{ row.longitude === undefined ? '143.84338591371284' : row.longitude }} </td>
                                    <td> {{ (row.speed === undefined ? "N/A" : (row.speed == 'N/A' ? row.speed : parseFloat(row.speed).toFixed(1))) }} </td>
                                    <td> {{ row.sensorTemp }}</td>
                                    <td> {{ row.sensorHumidity }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

            </div>

            </div>
            <template #modal-footer>
                <button v-b-modal.modal-close_visit class="btn btn-sm btn-secondary" @click="$bvModal.hide('device-pi-data-modal' + item.id)">Close</button>
            </template>
        </b-modal>

        <!-- data modal -->
        <b-modal :id="'device-data-modal' + item.id" size="xl" class="xxl-modal" scrollable @hide="deviceDataHide()">
            <!-- title-->
            <template #modal-title>
                <i class="fa-solid fa-chart-simple"></i><span class="modal-title">Data - {{ item.id }}</span>
            </template>

            <!-- content -->
            <div>
                <!-- left panel -->
                <div style="float:left; width: 32%;">
                    <!-- info box -->
                    <div style="position: relative; padding-top: 10px; padding-bottom: 0px;">
                            <img v-if="item.online" style="display: inline-block; width: 65px; vertical-align: top;" src="../assets/images/4.png" alt="..." />
                            <img v-else style="display: inline-block; width: 65px; vertical-align: top; opacity: 80%" src="../assets/images/4-offline.png" alt="..." />
                        <div style="display: inline-block; padding-left: 10px; padding-bottom: 0px;;">
                            <b>Device:</b> {{ item.id }}
                            <br />
                            <b>Type:</b> Cryopreservation Apparatus
                            <br />
                            <b>Location:</b> {{ item.location }}
                            <br />
                            <span v-if="item.online" class="badge bg-success">Online</span>
                            <span v-else class="badge bg-secondary">Offline</span>
                            <b-badge pill variant="info" style="margin-left: 10px;">{{(getDeviceOperationStatus())}}</b-badge>                                          
                        </div>

                        <!-- live temp -->
                        <div style="position: absolute; top: 0; right: 30px;">
                            <div v-if="item.id == 'Vitrafy-00001'">
                                <div v-if="item.online" class="bigTempDataContainer">
                                    <div class="bigTempData" :class="[$parent.deviceTempAndFlow[0].belowZero ? 'belowZero' : '']" style="font-size: 39px;">
                                        <img v-if="$parent.deviceTempAndFlow[0].belowZero" class="" style="position: initial; margin-top: -9px; margin-right: 0px; height: 34px;" src="../assets/images/snowflake.png" alt="...">
                                        {{ $parent.deviceTempAndFlow[0].temp }} °C
                                    </div>
                                    <div class="smallTempData">
                                        {{ $parent.deviceTempAndFlow[0].flow }} L/min
                                    </div>
                                </div>
                            </div>
                            <div v-if="item.id == 'Vitrafy-00002'">
                                <div v-if="item.online" class="bigTempDataContainer">
                                    <div class="bigTempData" :class="[$parent.deviceTempAndFlow[1].belowZero ? 'belowZero' : '']" style="font-size: 39px;">
                                        <img v-if="$parent.deviceTempAndFlow[1].belowZero" class="" style="position: initial; margin-top: -9px; margin-right: 0px; height: 34px;" src="../assets/images/snowflake.png" alt="...">
                                        {{ $parent.deviceTempAndFlow[1].temp }} °C
                                    </div>
                                    <div class="smallTempData">
                                        {{ $parent.deviceTempAndFlow[1].flow }} L/min
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="item.id == 'Vitrafy-00004'">
                                <div v-if="item.online" class="bigTempDataContainer">
                                    <div class="bigTempData" :class="[$parent.deviceTempAndFlow[2].belowZero ? 'belowZero' : '']" style="font-size: 39px;">
                                        <img v-if="$parent.deviceTempAndFlow[2].belowZero" class="" style="position: initial; margin-top: -9px; margin-right: 0px; height: 34px;" src="../assets/images/snowflake.png" alt="...">
                                        {{ $parent.deviceTempAndFlow[2].temp }} °C
                                    </div>
                                    <div class="smallTempData">
                                        {{ $parent.deviceTempAndFlow[2].flow }} L/min
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="item.id == 'Vitrafy-00005'">
                                <div v-if="item.online" class="bigTempDataContainer">
                                    <div class="bigTempData" :class="[$parent.deviceTempAndFlow[3].belowZero ? 'belowZero' : '']" style="font-size: 39px;">
                                        <img v-if="$parent.deviceTempAndFlow[3].belowZero" class="" style="position: initial; margin-top: -9px; margin-right: 0px; height: 34px;" src="../assets/images/snowflake.png" alt="...">
                                        {{ $parent.deviceTempAndFlow[3].temp }} °C
                                    </div>
                                    <div class="smallTempData">
                                        {{ $parent.deviceTempAndFlow[3].flow }} L/min
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="item.id == 'Vitrafy-00006'">
                                <div v-if="item.online" class="bigTempDataContainer">
                                    <div class="bigTempData" :class="[$parent.deviceTempAndFlow[4].belowZero ? 'belowZero' : '']" style="font-size: 39px;">
                                        <img v-if="$parent.deviceTempAndFlow[4].belowZero" class="" style="position: initial; margin-top: -9px; margin-right: 0px; height: 34px;" src="../assets/images/snowflake.png" alt="...">
                                        {{ $parent.deviceTempAndFlow[4].temp }} °C
                                    </div>
                                    <div class="smallTempData">
                                        {{ $parent.deviceTempAndFlow[4].flow }} L/min
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="item.id == 'Vitrafy-00007'">
                                <div v-if="item.online" class="bigTempDataContainer">
                                    <div class="bigTempData" :class="[$parent.deviceTempAndFlow[6].belowZero ? 'belowZero' : '']" style="font-size: 39px;">
                                        <img v-if="$parent.deviceTempAndFlow[6].belowZero" class="" style="position: initial; margin-top: -9px; margin-right: 0px; height: 34px;" src="../assets/images/snowflake.png" alt="...">
                                        {{ $parent.deviceTempAndFlow[6].temp }} °C
                                    </div>
                                    <div class="smallTempData">
                                        {{ $parent.deviceTempAndFlow[6].flow }} L/min
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="item.id == 'Vitrafy-00009'">
                                <div v-if="item.online" class="bigTempDataContainer">
                                    <div class="bigTempData" :class="[$parent.deviceTempAndFlow[7].belowZero ? 'belowZero' : '']" style="font-size: 39px;">
                                        <img v-if="$parent.deviceTempAndFlow[7].belowZero" class="" style="position: initial; margin-top: -9px; margin-right: 0px; height: 34px;" src="../assets/images/snowflake.png" alt="...">
                                        {{ $parent.deviceTempAndFlow[7].temp }} °C
                                    </div>
                                    <div class="smallTempData">
                                        {{ $parent.deviceTempAndFlow[7].flow }} L/min
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="item.id == 'Vitrafy-00011'">
                                <div v-if="item.online" class="bigTempDataContainer">
                                    <div class="bigTempData" :class="[$parent.deviceTempAndFlow[8].belowZero ? 'belowZero' : '']" style="font-size: 39px;">
                                        <img v-if="$parent.deviceTempAndFlow[8].belowZero" class="" style="position: initial; margin-top: -9px; margin-right: 0px; height: 34px;" src="../assets/images/snowflake.png" alt="...">
                                        {{ $parent.deviceTempAndFlow[8].temp }} °C
                                    </div>
                                    <div class="smallTempData">
                                        {{ $parent.deviceTempAndFlow[8].flow }} L/min
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="item.id == 'Vitrafy-HP00001'">
                                <div v-if="item.online" class="bigTempDataContainer">
                                    <div class="bigTempData" :class="[$parent.deviceTempAndFlow[6].belowZero ? 'belowZero' : '']" style="font-size: 39px;">
                                        <img v-if="$parent.deviceTempAndFlow[6].belowZero" class="" style="position: initial; margin-top: -9px; margin-right: 0px; height: 34px;" src="../assets/images/snowflake.png" alt="...">
                                        {{ $parent.deviceTempAndFlow[6].temp }} °C
                                    </div>
                                    <div class="smallTempData">
                                        {{ $parent.deviceTempAndFlow[6].flow }} L/min
                                    </div>
                                </div>
                            </div>
                            <!-- <hr style="margin-bottom: 0;" /> -->
                        </div>
                    </div>

                    <!-- TODO: We can add machine live data such as compressor power % and kW, etc -->
                    <!-- temp chart -->
                    <!-- <div style="padding-right: 30px; padding-bottom: 1px;;">
                            <DeviceDataRealTime :item="item" ref="DeviceDataRealTime"/>
                    </div> -->

                    <!-- device location -->
                    <div id="device-location" style="float:left; width: 100%; padding-right: 30px; /*margin-top: -20px;*/">
                        <!-- <hr /> -->
                        <PackagingTracking_dynamic ref="PackagingTracking_dynamic" :item="item" />
                    </div>

                    <!-- system info -->
                    <div id="data-modal-sys-info" style="float: left; width: 100%; padding-right: 30px;">
                        <hr/>
                        <table id="info-table" v-bind:class="{'whiteTable':!item.online}" style="margin-bottom: 0px;">
                            <tr>
                                <td>CPU</td>
                                <td style="padding-left: 10px;">{{ item.deviceCPU }}%</td>
                                <td class = "chart">
                                    <div class="progress" v-bind:class="{'hide-element':item.offline}">
                                        <div class="progress-bar" role="progressbar" v-bind:style="{ width: item.deviceCPU + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>MEM</td>
                                <td style="padding-left: 10px;">{{ item.deviceMEM }}%</td>
                                <td class = "chart">
                                    <div class="progress" v-bind:class="{'hide-element':item.offline}">
                                        <div class="progress-bar" role="progressbar" v-bind:style="{ width: item.deviceMEM + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                </td>
                            </tr> 
                            <tr v-if="item.sensorDevice && item.online" class="info-title">
                                <td>SENSOR</td>
                                <td colspan="2" style="padding-left: 5px;">{{ item.sensorData }} (DHT22 temperature-humidity sensor)</td>
                            </tr>
                        </table>
                    </div>

                </div>

                <!-- right panel -->
                <div style="float:left; width: 68%;">
                    <!-- tabs  -->
                    <div style="width: 100%; float: left; overflow: auto">
                        <b-tabs content-class="mt-3">
                            <b-tab title="History (Batches)">

                                <DeviceDataBatches :item="item" :autoUpdateDeviceData="autoUpdateDeviceData"/>

                            </b-tab>
                            <b-tab title="Trends">

                                <DeviceData :item="item" ref="DeviceData"/>

                            </b-tab>
                            <b-tab title="Refrigeration">

                                <DeviceImageData :item="item" ref="DeviceImageData"/>

                            </b-tab>
                        </b-tabs>
                    </div>
                </div>

            </div>

            <!-- footer -->
            <template #modal-footer>
                <button v-b-modal.modal-close_visit class="btn btn-sm btn-secondary" @click="$bvModal.hide('device-data-modal' + item.id)">Close</button>
            </template>
        </b-modal>

        <!-- miot data modal -->
        <b-modal :id="'miot-data-modal' + item.id" size="xl" class="xxl-modal" scrollable @hide="miotModalHide('miot-data-modal' + item.id)">
            <!-- title-->
            <template #modal-title>
                <i class="fa-solid fa-chart-simple"></i><span class="modal-title">Data - {{ item.id }}</span>
            </template>
            
            <MIoTCard :item="item" :autoUpdateDeviceData="autoUpdateDeviceData"/>
            
            <!-- footer -->
            <template #modal-footer>
                <button v-b-modal.modal-close_visit class="btn btn-sm btn-secondary" @click="$bvModal.hide('miot-data-modal' + item.id)">Close</button>
            </template>
        </b-modal>

        <!-- control  modal -->
        <b-modal :id="'device-control-modal' + item.id" :title="item.id" size="xl" scrollable>
            <div>
                
                <iframe style="width: 100%; height: 750px;" src="http://192.168.1.244:8088/data/perspective/client/Bio_Freeze/menu"></iframe>

            </div>
            <template #modal-footer>
                <button v-b-modal.modal-close_visit class="btn btn-sm btn-secondary" @click="$bvModal.hide('device-control-modal' + item.id)">Close</button>
            </template>
        </b-modal>

    </div>

</template>

<script>
    //import LiveDataModal from '@/components/LiveDataModal.vue';
    import PackagingTracking_dynamic from './PackagingTracking_dynamic.vue';
    import DeviceDataBatches from '@/components/DeviceData/DeviceDataBatches.vue';
    import DeviceData from '@/components/DeviceData/DeviceData.vue';
    import DeviceImageData from '@/components/DeviceData/DeviceImageData.vue';
    import MIoTCard from './DeviceData/MIoTCard.vue';
    import Chart from 'chart.js';
    // import DatePicker from 'vue2-datepicker';
    // import 'vue2-datepicker/index.css';

    export default {
        name: 'device-card',
        components: {
            // LiveDataModal,
            // LiveData,
            PackagingTracking_dynamic,
            DeviceData,
            DeviceImageData,
            DeviceDataBatches,
            MIoTCard,
            // DatePicker,
        },
        data: function () {
            return {
                deviceDataDateRange: [],
                sensorData: [],
                patentTest: "this is a parent!",
                SensorData: "", 
                piData: {
                    type: "line",
                    data: {
                        labels: [],
                        datasets: [
                            {
                                label: "Temperature °C",
                                data: [],
                                backgroundColor: "rgba(54,73,93,.5)",
                                borderColor: "#36495d",
                                borderWidth: 3,
                                radius: 0
                            }                  
                        ]
                    },
                    options: {
                        maintainAspectRatio: false,
                        legend: {
                            display: false
                        },                    
                        animation: {
                            duration: 0
                        },                    
                        responsive: true,
                        lineTension: 1,
                        scales: {
                            yAxes: [
                                {
                                    ticks: {
                                        beginAtZero: false,
                                        padding: 25
                                    }
                                }
                            ]
                        }      
                    }
                },
                temperature: null,
                temperatureChange: null,
                piData2: {
                    type: "line",
                    data: {
                        labels: [],
                        datasets: [
                            {
                                label: "Humidity %",
                                data: [],
                                backgroundColor: "rgba(71, 183,132,.5)",
                                borderColor: "#47b784",
                                borderWidth: 3,
                                radius: 0
                            }
                        ]
                    },
                    options: {
                        maintainAspectRatio: false,
                        legend: {
                            display: false
                        },                       
                        animation: {
                            duration: 0
                        },                    
                        responsive: true,
                        lineTension: 1,
                        scales: {
                            yAxes: [
                                {
                                    ticks: {
                                        beginAtZero: false,
                                        padding: 25
                                    }
                                }
                            ]
                        }                     
                    }
                },
                humidity: null,
                humidityChange: null,
                autoFetchData: false,
                autoUpdateDeviceData: false,

                deviceBatchData: [],

                map_zoom_level: null,
                deviceLocationHistory: [],
            };
        },
        props: ['item'],
        mounted() {
            // Pi Temp sensor API auto-fetch
            this.timer2 = setInterval(() => {
                if(this.autoFetchData) {
                    this.getSensorData();
                }
            }, 1000) // 1 sec
            // device data auto-fetch
            // console.log("autoUpdateDeviceData = " + this.autoUpdateDeviceData);
        },
        beforeDestroy() {
            clearInterval(this.timer2);
        },
        methods: {
            getDeviceSleepStatus(timeStamp)
            {
                // Get the current time in milliseconds
                const currentTime = new Date().getTime();

                // Calculate the difference between the current time and the provided timestamp
                const difference = currentTime - timeStamp;

                // Check if the difference is greater than one minute (60 seconds * 1000 milliseconds)
                return difference > 60 * 1000;
            },
            getLiveStatusColour(){
                return this.getDeviceSleepStatus(this.item.deviceTimestamp)
                ? 'grey' // Change this to the color you want for timestamps more than one minute ago
                : 'red'; // Change this to the color you want for timestamps less than one minute ago 
            },
            deviceDataShow() {
                this.autoUpdateDeviceData = true;
                // console.log("device ID = " + this.item.id);
                // console.log("autoUpdateDeviceData = " + this.autoUpdateDeviceData);
            },           
            deviceDataHide() {
                this.autoUpdateDeviceData = false;
                // console.log("autoUpdateDeviceData = " + this.autoUpdateDeviceData);
            },
            miotModalHide(){this.autoUpdateDeviceData = false;},
            miotModalShow(){this.autoUpdateDeviceData = true; this.pi2DataClick(); },
            pi2DataClick(){
                console.log("MODAL opened!");
                this.autoFetchData = true;
                scroll(0,0);
                //this.$parent.pi2DataClick();
            },
            pi2DataHide(){
                console.log("MODAL closed!");
                this.autoFetchData = false;
                //this.$parent.pi2DataHide();
            },
            getDeviceOperationStatus()
            {
                var device_op_status = null
                if (this.item.device_operation_status)
                {
                    device_op_status = this.item.device_operation_status
                }
                return device_op_status
            },
            async getSensorData() {
                // for Packaging Device 2
                let url = "https://xct6d7fy58.execute-api.ap-southeast-2.amazonaws.com/beta"; 

                // for Packaging Device 3
                if(this.item.id == "Packaging Device 3") {
                    url = "https://s9tfb3de53.execute-api.ap-southeast-2.amazonaws.com/default"; 
                }

                let headers = {
                    'x-api-key': 'NMKFcHIzMT7ToX0O9eRXW7yXA22zGM0B7ddc8Xpy'
                };                

                try {
                    const response = await this.$http.get(
                        url,
                        {headers: headers}
                    );

                    //console.log(response.data.Items[0].itemData[29]);

                    var sensorDataArray = [];
                    var datasetZero = [];
                    var datasetOne = [];
                    var labels = [];

                    // console.log("---DEBUG---")
                    // console.log(response.data);
                    // console.log("---END DEBUG---")


                    for(var i = 0; i < response.data.Items[0].itemData.length; i++) {

                        // tempdata object
                        var tempData = response.data.Items[0].itemData[i].deviceTempData.split(" "); // example "1650500757 21.2 49.""

                        // console.log("Pi Temp Data: ")
                        // console.log(tempData)

                        // format timestamp
                        var adjustedTimestamp = parseInt(tempData[0] + "000");

                        var ts = new Date(parseInt(adjustedTimestamp));
                        //console.log(ts);

                        var tsa = ts.toLocaleString('en-AU').toUpperCase();
                        var tsb = ts.toLocaleString('en-us', {  weekday: 'short' }) + ' ' + tsa;
                        var tsc = tsb.replace(',', '');

                        var sensorData = {
                            timestamp: tsc,
                            sensorTemp: tempData[1],
                            sensorHumidity: tempData[2],
                            latitude: tempData[3],
                            longitude: tempData[4],
                            speed: tempData[5],
                        }

                        if (this.item.id === "Packaging Device 2"){
                            //TODO: Hard-coded to default to Vitrafy Lab for now...
                            sensorData.latitude = (Math.floor(parseFloat(sensorData.latitude, 1)) == 0.0 ? -37.53092219073088 : parseFloat(sensorData.latitude));
                            sensorData.longitude = (Math.floor(parseFloat(sensorData.longitude, 1)) == 0.0 ? 143.84338591371284 : parseFloat(sensorData.longitude));
                            this.item.coords = {lat: parseFloat(sensorData.latitude), lng: parseFloat(sensorData.longitude)};
                            this.map_zoom_level = 1;
                        } 

                        sensorDataArray.push(sensorData);
                        datasetZero.push(tempData[1]);
                        datasetOne.push(tempData[2]);

                        var cts = ts.toString().split(' ');
                        labels.push(cts[4]);
                    }

                    // data for table
                    this.sensorData = sensorDataArray.reverse();

                    // data for chart and redraw chart
                    this.piData.data.labels = labels;
                    this.piData.data.datasets[0].data = datasetZero;
                    this.temperature = datasetZero[29];

                    if(this.temperature > datasetZero[28]) {
                        this.temperatureChange = "U"
                    } else if(this.temperature < datasetZero[28]) {
                        this.temperatureChange = "D"
                    } else {
                        this.temperatureChange = "-"
                    }

                    this.piData2.data.labels = labels;
                    this.piData2.data.datasets[0].data = datasetOne;     
                    this.humidity = datasetOne[29]      
                    
                    if(this.humidity > datasetOne[28]) {
                        this.humidityChange = "U"
                    } else if(this.humidity < datasetOne[28]) {
                        this.humidityChange = "D"
                    } else {
                        this.humidityChange = "-"
                    }                
                    
                    // Temperature  Chart
                    const ctx = document.getElementById('device-chart');
                    new Chart(ctx, this.piData);       
                    
                    // Humidity  Chart
                    const ctx2 = document.getElementById('device-chart-2');
                    new Chart(ctx2, this.piData2);            
                    
                    document.getElementById("live-data-loading").style.display = 'none';
                    document.getElementById("live-data-container").style.display = 'block';                

                } catch (error) {
                    console.log(error);
                }
            },
            getCurrentDateTime() {
                const d = new Date();

                const dd = String(d.getDate()).padStart(2, "0");
                const mm = String(d.getMonth() + 1).padStart(2, "0");
                const yyyy = d.getFullYear();

                let hh = d.getHours(); // 0-23
                const ampm = hh >= 12 ? "PM" : "AM";
                hh = hh % 12;
                if (hh === 0) hh = 12;

                const HH = String(hh).padStart(2, "0");
                const min = String(d.getMinutes()).padStart(2, "0");

                return `${dd}/${mm}/${yyyy} ${HH}:${min} ${ampm}`;
            },
            timeSince(dateTimeStr) {
                if (!dateTimeStr) return "";

                // Parse "24/01/2026 08:17 PM"
                const m = dateTimeStr.match(
                /^(\d{2})\/(\d{2})\/(\d{4})\s+(\d{2}):(\d{2})\s+(AM|PM)$/i
                );
                if (!m) return "Invalid date";

                const dd = parseInt(m[1], 10);
                const mm = parseInt(m[2], 10) - 1; // JS months 0-11
                const yyyy = parseInt(m[3], 10);

                let hh = parseInt(m[4], 10);
                const min = parseInt(m[5], 10);
                const ampm = m[6].toUpperCase();

                // Convert to 24-hour
                if (ampm === "PM" && hh !== 12) hh += 12;
                if (ampm === "AM" && hh === 12) hh = 0;

                const then = new Date(yyyy, mm, dd, hh, min, 0);

                // Diff (absolute value so it works for past/future)
                let diffMs = Math.abs(Date.now() - then.getTime());

                const secTotal = Math.floor(diffMs / 1000);

                const days = Math.floor(secTotal / 86400);
                const hours = Math.floor((secTotal % 86400) / 3600);
                const minutes = Math.floor((secTotal % 3600) / 60);
                const seconds = secTotal % 60;

                return `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds`;
            },                   
        }
    }
</script>

<style>
    #data-modal-sys-info > #info-table td {
        padding-bottom: 0px;
    }

    #data-modal-sys-info .progress-bar {
        background-color: #76b8e0eb;
    }

    #info-table td {
        border: none;
        padding: 0;
        padding-bottom: 8px;
    }

    #info-table .info-title {
        padding-right: 35px;
    }

    .rotate {
        animation: rotation 8s infinite linear;
    }

    @keyframes rotation {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(359deg);
        }
    }

    .content-container {
        width: 217px;
    }

    .bigTempDataContainer {
        position: relative;
        /* margin-top: -5px; */
    }

    .bigTempDataContainer i {
        position: absolute;
        top: 9px;
        left: 6px;
    }

    .bigTempDataContainer img {
        position: absolute;
        height: 32px;
        top: 9px;
        left: 8px;
    }

    .bigTempData {
        font-size: 32px; 
        text-align: right;
    }

    .belowZero {
        color: #0a58ca;
    }

    .smallTempData {
        font-size: 16px;
        text-align: right;
        margin-top: -9px;
    }

    [id^="device-data-modal"] > .modal-dialog {
        max-width: 95% !important;
    }

    .modal-title {
        color: inherit;
        font-size: 1.25rem;
        /* padding-left: 10px; */
    }

    .data-button {
        position: absolute;
        right: 0;
    }

    #device-location-mobile {
        margin-top: 30px;
        display: none !important;
    }

    @media (max-width: 991px) {
        #device-location-desktop {
            display: none !important;
        }
        #device-location-mobile {
            display: block !important;
        }        
        #device-data {
            width: 100% !important;
            padding: 0 !important;
        }
    }

    .k-grid-header {
        box-shadow: rgb(0 0 0 / 20%) 0px 3px 4px 0px, rgb(0 0 0 / 14%) 0px 3px 3px -2px, rgb(0 0 0 / 12%) 0px 1px 8px 0px !important;
    }

    .k-grid-content {
        cursor: pointer;
    }

    
</style>